// extracted by mini-css-extract-plugin
export default {"HostServiceDetailPrices__Header":"HostServiceDetailPrices_HostServiceDetailPrices__Header__EHMFy"};